{
    "title": "Application Approved!",
    "subtitle": "Now you can use Izzi Wallet to manage your money"
}